import script from "./InterestsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterestsModal.vue?vue&type=script&setup=true&lang=ts"

import "./InterestsModal.vue?vue&type=style&index=0&id=8d680f76&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d680f76"]])

export default __exports__